import type { useSingleton } from "@tippyjs/react";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { TimerIcon } from "@/icons";
import { headerActiveButtonAtom } from "@/interface/AppStore";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";
import styles from "../RightBar.module.scss";
import { formatTime } from "./utils";

type TimerButtonProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    className?: string;
    isTimerRunning: boolean;
    timerTime: string;
    isTimerActive: boolean;
};

export const TimerButton = ({
    singletoneTarget,
    className,
    timerTime,
    isTimerRunning,
    isTimerActive,
}: TimerButtonProps) => {
    const { t } = useTranslation();
    const setActiveHeaderButton = useSetAtom(headerActiveButtonAtom);

    const click = () => {
        setActiveHeaderButton("timer");
    };
    const [min, sec] = timerTime.split(":");

    return (
        <Tooltip singleton={singletoneTarget} content={t("header.timer")}>
            <BottomBarItem className={className} active={isTimerActive} onClick={click}>
                <TimerIcon />
                {isTimerRunning && (
                    <span className={styles.timerTime}>
                        {`${formatTime(Number(min))}:${formatTime(Number(sec))}`}
                    </span>
                )}
            </BottomBarItem>
        </Tooltip>
    );
};
